import React from 'react';
import { DeleteOutlined, MoreOutlined, PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { TaskAttachment } from '../../../types/TaskAttachment';
import '../styles/TaskView.scss';
import CustomTooltip from '../../../components/UI/Tooltip/CustomTooltip';
import { BaseAttachments } from './BaseAttachments';
import BaseDropdown from '../../../components/UI/Dropdown/BaseDropdown';

interface TaskAttachmentsProps {
  attachments: TaskAttachment[];
  onDeleteAttachment: (attachment: TaskAttachment) => void;
  onDeleteAllAttachments: () => void;
  onAddAttachment: () => void;
}

export const TaskAttachments: React.FC<TaskAttachmentsProps> = ({
  attachments,
  onDeleteAttachment,
  onDeleteAllAttachments,
  onAddAttachment,
}) => {
  const optionsMenuItems = [
    {
      key: 'delete',
      label: <div className="justify-start text-red-600 text-sm font-normal">Delete All</div>,
      icon: <DeleteOutlined className="text-red-600" />,
    },
  ];

  if (!attachments || attachments.length === 0) {
    return null;
  }

  const sortedAttachments = attachments.sort((a, b) => {
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
  });

  const renderHeader = () => (
    <div className="h-6 flex items-center gap-1 text-brand-grey-dark text-xs font-semibold ml-[-28px]">
      <div className="relative w-6 h-4 flex items-center justify-center right-0 top-0">
        <BaseDropdown
          menu={{
            items: optionsMenuItems,
            onClick: (e) => {
              e.domEvent.stopPropagation();
              if (e.key === 'delete') {
                onDeleteAllAttachments();
              }
            },
          }}
          trigger={['click']}
          placement="bottom"
          overlayStyle={{ width: 240 }}
        >
          <Button
            type="link"
            className="h-6 w-6 p-0 bg-white rounded shadow border border-neutral-300 hover:border-brand-taskonio-green justify-center items-center gap-1 inline-flex task-attachments-section__options-menu"
          >
            <MoreOutlined className="text-neutral-900" />
          </Button>
        </BaseDropdown>
      </div>
      Attachments
      <div className="w-5 h-5 flex items-center justify-center bg-neutral-200 text-neutral-900 text-xs font-semibold rounded p-0.5">
        {sortedAttachments.length}
      </div>
      <div className="task-attachments-section__add-attachment">
        <CustomTooltip title="Add Attachment">
          <Button
            type="link"
            className="h-6 ml-1 p-0 bg-white rounded shadow border border-neutral-300 hover:border-brand-taskonio-green justify-start items-center gap-1 inline-flex"
            onClick={onAddAttachment}
          >
            <PlusOutlined className="text-neutral-900 hover:text-brand-taskonio-green p-1" />
          </Button>
        </CustomTooltip>
      </div>
    </div>
  );

  return (
    <BaseAttachments
      attachments={sortedAttachments}
      onDeleteAttachment={onDeleteAttachment}
      renderHeader={renderHeader}
      className="flex flex-col gap-2 mt-6 task-attachments-section"
    />
  );
};
